export default __webpack_public_path__ + "11574e8ffc9690ad773c1bb235253f37.png";